import { Feature, Map } from "ol";
import WKT from "ol/format/WKT";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Fill, Stroke, Style, Text } from "ol/style";
import { Circle } from "ol/geom";
import { ZoneOfInterestDto } from "src/app/bo/zoneOfInterest";
import { ZoneOfInterestService } from "src/app/services/zone-of-interest.service";
import MapConstants from "../constants";

export class ZoneOfInterestLayer {

    private readonly source: VectorSource;
    private readonly vectorLayer: VectorLayer<VectorSource>;
    private siteId: number;

    public constructor(
        private readonly zoiService: ZoneOfInterestService,
        private readonly map: Map,
        siteId: number,
        zIndex: number
    ) {
        this.siteId = siteId;
        this.source = new VectorSource();
        this.vectorLayer = new VectorLayer({
            source: this.source,
        });
        this.vectorLayer.setZIndex(zIndex);
        this.map.addLayer(this.vectorLayer);
    }

    public setVisible(visible: boolean): void {
        this.vectorLayer.setVisible(visible);
    }

    public changeSite(siteId: number): void {
        this.siteId = siteId;
        this.refresh();
    }

    public refresh(): void {
        this.source.clear();
        this.zoiService.getAll(this.siteId).subscribe(zones => {
            zones.forEach(zone => this.addZone(zone));
        });
    }

    private addZone(zone: ZoneOfInterestDto): void {
        let feature: Feature;

        if (zone.geometryType === 'circle' && zone.centerX != null && zone.centerY != null && zone.radius != null) {
            feature = new Feature({
                geometry: new Circle([zone.centerX, zone.centerY], zone.radius),
            });
        } else if (zone.geometryType === 'polygon' && zone.wktString) {
            const wkt = new WKT();
            feature = wkt.readFeature(zone.wktString, {
                dataProjection: 'EPSG:3857',
                featureProjection: 'EPSG:3857',
            }) as Feature;
        } else {
            return;
        }

        feature.set(MapConstants.FEATURE_NAME, MapConstants.FEATURE_TYPE.zone_of_interest);
        feature.set(MapConstants.ZOI_DATA, zone);

        feature.setStyle(this.createStyle(zone));
        this.source.addFeature(feature);
    }

    private createStyle(zone: ZoneOfInterestDto): Style {
        return new Style({
            fill: new Fill({
                color: 'rgba(255, 165, 0, 0.2)',
            }),
            stroke: new Stroke({
                color: 'rgba(255, 140, 0, 0.8)',
                width: 2,
                lineDash: [6, 4],
            }),
            text: new Text({
                font: '13px Calibri,sans-serif',
                text: zone.name,
                fill: new Fill({ color: '#fff' }),
                backgroundFill: new Fill({ color: 'rgba(255, 140, 0, 0.7)' }),
                padding: [3, 5, 3, 5],
                overflow: true,
            }),
        });
    }
}
